import React from 'react';

import {
  ToggleButtonGroup,
  ToggleButton,
  ViewModuleIcon,
  ViewListIcon,
} from '@gogame/components';

import {
  VIEW_MODE_DATATABLE,
  VIEW_MODE_TILES,
} from 'scenes/Gallery/GalleryPage/constants';

export default ({ setViewMode, viewMode }) => {
  const handleSwitchMode = () => {
    if (viewMode === VIEW_MODE_DATATABLE) {
      setViewMode(VIEW_MODE_TILES);
    } else if (viewMode === VIEW_MODE_TILES) {
      setViewMode(VIEW_MODE_DATATABLE);
    }
  };

  return (
    <ToggleButtonGroup
      size={'small'}
      color={'primary'}
      exclusive={true}
      onChange={handleSwitchMode}
      value={viewMode}
    >
      <ToggleButton value={VIEW_MODE_DATATABLE} tooltip={'View as table'}>
        <ViewListIcon fontSize={'small'} />
      </ToggleButton>
      <ToggleButton value={VIEW_MODE_TILES} tooltip={'View as grid'}>
        <ViewModuleIcon fontSize={'small'} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
